import { ActionTypes, ReduxAction } from './types';

import { Dispatch } from 'redux';
import { WaehrungService } from '../../api';

export const getWaehrungen = () => async (dispatch: Dispatch<ReduxAction>) => {
  new WaehrungService().getAllWaehrungen().then(result => {
    dispatch({
      type: ActionTypes.GET_WAEHRUNGEN,
      payload: result.data,
    });
  });
};
